import * as React from 'react';
import { useIntl, useDispatch, useSelector } from '@grandvisionhq/state';
import { selectShippingMethod } from '../../actions.js';
import { getSelectedShippingMethod } from '../../selectors.js';
import { AlternativeShippingMethodsList } from './AlternativeShippingMethodsList.js';

const AlternativeShippingMethodsListContainer = ({ onNextStep , onModalClose , onStoreSelect , onPickupPointSelect  })=>{
    const { getLabel  } = useIntl();
    const dispatch = useDispatch();
    const selectedShippingMethod = useSelector(getSelectedShippingMethod);
    const labels = React.useMemo(()=>({
            description: getLabel('cart.item.subscription.deliveryInterval'),
            buttonCaptionLabel: getLabel('common.actions.continue'),
            free: getLabel('common.free'),
            back: getLabel('cart.actions.goBack'),
            errorTitle: getLabel('cart.shippingMethod.error.title'),
            errorDescription: getLabel('cart.shippingMethod.error.description')
        })
    , [
        getLabel
    ]);
    const handleSubmit = React.useCallback((selectedAlternativeShippingMethod)=>{
        dispatch(selectShippingMethod({
            shippingMethod: {
                method: selectedAlternativeShippingMethod,
                isValid: true,
                isTouched: true
            }
        }));
        onNextStep(true);
    }, [
        dispatch,
        onNextStep
    ]);
    return /*#__PURE__*/ React.createElement(AlternativeShippingMethodsList, {
        onModalClose: onModalClose,
        labels: labels,
        selectedShippingMethod: selectedShippingMethod,
        onSubmit: handleSubmit,
        onPickupPointSelect: onPickupPointSelect,
        onStoreSelect: onStoreSelect
    });
};

export { AlternativeShippingMethodsListContainer };
//# sourceMappingURL=AlternativeShippingMethodsListContainer.js.map
